// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"176":"60f2a3d5","227":"cf1b4635","242":"3ba12ba6","453":"06fd2d69","478":"c0bc0387","788":"94957722","917":"952557af","924":"19609a0e","955":"bedb0f24","972":"3e8653e3","982":"6155dd89","988":"79d13787"}[chunkId] + ".chunk.js";
};